<script>
    import BlogSummary from '../components/BlogSummary.svelte';
    export let short = false;
    export let blogUrl = "treenaa-vauvan-kanssa";
    let title = "Treeni vauvan kanssa";
    let author = "Mata";
    let blogDate = "28.4.2020";
    let titlePic = "vauva_treeni.jpg";
    let firstPara = "Vauvajumppa eli yhdessä vauvan kanssa treenaaminen on parhaimmillaan paitsi vanhemmalle tehokas liikuntahetki, myös mukavaa yhdessäoloa molemmille osapuolille.";
</script>
<!--  Blogi koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}
<BlogSummary blogPath={blogUrl} title={title} titlePic={titlePic} blogDate={blogDate} firstPara={firstPara}></BlogSummary>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">{author} | {blogDate}</div>
            <div class="blogMainImage" style="background-image: url('/svelte-site/img/blog/{titlePic}')"></div>
            <p>{firstPara}</p>

            <p>
                Vauvatreenit sopivatkin hyvin vanhemmalle yhteiseksi tekemiseksi vauvan kanssa. Ota
                vauva mukaan treeniin, niin treeneissä tarvittava lisäpaino on käden ulottuvillasi. Vauvan kasvaessa
                myös tehoa tulee treeneihin lisää.
            </p>
            <p>Jos synnytyksestä on vain vähän aikaa, odotathan kuitenkin jälkitarkastuksen eli n. 8 viikkoa synnytyksestä 
                ennen harjoittelun aloittamista, sekä kuulostele itseäsi ja kehosi tuntemuksia. Muistathan olla armollinen 
                itsellesi. Synnytyksestä palautuminen on pitkä prosessi ja menee jopa 6-12 kk, että kroppa on täysin palautunut.
            </p>
            <p>
                Voit koota treenin sen mukaan, paljonko voit ja haluat käyttää aikaa. Valitse sopiva määrä liikkeitä,
                tee jokaista liikettä 2-3 sarjaa ja toistoja 10-15 tai niin monta kuin jaksat hyvällä tekniikalla tehdä.
                Pyri valitsemaan monipuolisesti liikkeitä niin että saat koko kehon haastettua. Lisää toistoja, kun
                huomaat kunnon kohoavan.
            </p>
            Huomioi liikevalinnassa oma ja lapsen turvallisuus. Mikäli olet vasta synnyttänyt (alle 6 kk), tulisi kovia
            ponnisteluja ja vatsalihaksiin kohdistuvaa suoraa rasitusta välttää.
            <p>
                Alla on kaksi esimerkkitreeniä tehtäväksi. Treenien liikkeet löytyvät alla olevalta videolta. Videolla
                on koostettuna myös muutamia muitakin liikkeitä joita voit tehdä yhdessä vauvan kanssa vaikka kotona.
                Videon liikkeistä osa edellyttää että lapsi osaa jo tukea omaa niskaa ja äidin tulisi olla jo melko
                hyvin palautunut synnytyksestä. Osa liikkeistä on haastavampia, tee niitä oman jaksamisen mukaan.
                Liikkeet sopivat hyvin myös isän ja vauvan yhteiseen treenihetkeen.
            </p>

            <iframe width="560" height="315" src="https://www.youtube.com/embed/JIPBRHydUII" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    title="Video"
                    allowfullscreen></iframe>


            <h3>Helppo treeni pienemmän vauvan kanssa tehtäväksi.</h3>
            <p>Tämä treeni sopii pienemmänkin vauvan kanssa tehtäväksi.</p>
             <p>Lämmittelyksi: Vuorikiipeilijä, 30-60 sek<br /><br />

                Tee liikkeet sarjoina 2-3 x 10-15 toistoa/liike, palautukset sarjojen välillä 1-2 min tai tarpeen
                mukaan.
            </p>
            <ul>
                <li>Penkiltä nousu (kyykky)</li>
                <li>Hyvää huomenta</li>
                <li>Ylösnosto polviasennossa</li>
                <li>Punnerrus selinmaaten</li>
                <li>Vartalon kierto seisten</li>
            </ul>

            <h3>Hieman haastavampi treeni</h3>
            <p>
                Tämä treeni sopii kun lapsi kannattelee jo itseään ja äiti on palautunut synnytyksestä jo
                melko hyvin. Erinomainen treeni myös isille!
            </p>
            <p>
                Tee liikkeet kiertoharjoitteluna 40 sek työ/20 sek tauko, 2-3 kierrosta. Pidä kierrosten välissä hieman
                pidempi 2-3 min tauko.
            </p>
            <ul>
                <li>Vuorikiipeilijä</li>
                <li>Askelkyykky pohjenousulla</li>
                <li>Punnerrus</li>
                <li>Lantion nostot</li>
                <li>Vatsarutistus</li>
                <li>Thruster</li>
            </ul>


        </article>



        <section class="container">
            <h2>Lue seuraavaksi</h2>
            <div class="row">
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='vastuskuminauhat_6_vinkkia' title='6 vinkkiä vastuskuminauhojen hyödyntämiseen' titlePic='2014/etunojapunnerrus2.jpg' blogDate='' firstPara='Vastuskuminauhat ovat hauska ja tehokas tapa tuoda monipuolisuutta ja vaihtelua harjoitteluun. Lue tästä vinkit vaskuskuminauhojen hyödyntämiseen treeneissä.'></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='selkavaivat_kuriin_treenaamalla' title='Selkävaivaisena treenaamisesta' 
                    titlePic='2014/levytanko.jpg' firstPara='Selkävaivat ovat nykyisin valitettavan yleisiä. Tilastojen mukaan vähintään joka kolmas suomalainen sanoo kärsineensä selkävaivoista viimeisen puolen vuoden aikana. Yleisimmit kivut esiintyvät alaselän alueella.' blogDate=''></BlogSummary>
                </article>
                <article class="blog col-xs-12 col-md-4">
                    <BlogSummary blogPath='nilkan-liikkuvuus-ja-huolto-osa1' title='Nilkan liikkuvuus ja huolto' titlePic='nilkat.jpg' blogDate='' firstPara='Levytangolla tehtävistä kyykkyliikkeistä etu- ja takakyykky ovat ne tunnetuimmat ja tehokkaimmat versiot. Olen viimeisinä vuosina yrittänyt tehdä selkäni vuoksi enemmän etukyykkyä kuin takakyykkyä, sillä etukyykky on selälle kevyempi vaihtoehto.'></BlogSummary>
                </article>
            </div>
        </section>


    </div>
{/if}

<style>


</style>